<div class="license-settings setting-page">
    <legend>License</legend>
    <arm-form (submitForm)="onSubmit()" [disableSubmit]="!canSubmit">
        <arm-form-title>LICENSE</arm-form-title>

        <div class="settings-section">
            <mat-form-field class="fullWidth">
                <mat-label>Machine Id</mat-label>
                <input [(ngModel)]="machineId.machineId" matInput name="machineId" disabled>
                <button type="button" mat-button matSuffix mat-icon-button
                        #tooltip="matTooltip"
                        [cdkCopyToClipboard]="machineId.machineId"
                        (mouseenter)="mouseEnterCopyToClipboard()"
                        (click)="copyMachineIdToClipboard()"
                        matTooltip="Copy to clipboard"
                        matTooltipPosition="right">
                    <mat-icon class="clear-button">file_copy</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="fullWidth">
                <mat-label>License Key</mat-label>
                <input [(ngModel)]="license.license" matInput name="licenseKey" required>
                <mat-error>
                    License Key is <strong>required</strong>
                </mat-error>
            </mat-form-field>

          <div class="license-features" *ngIf="license.productKey">
            <div class="license-item">
              <p class="license-key">Product Key: {{license.productKey}}</p>
            </div>
          </div>

          <div class="license-features">
            <div class="license-item">
              <p class="license-key">Arm Flavor: {{license.armFlavor | titlecase}}</p>
            </div>
          </div>

        </div>

        <arm-form-title>LICENSE DETAILS</arm-form-title>
        <div class="settings-section">
            <div class="license-features">
                <div class="license-item">
                    <p class="license-key">Expiration Date:</p>
                    <label class="license-value">{{license.expirationDate}}</label>
                </div>
                <div *ngFor="let feature of license.features" class="license-item">
                    <p class="license-key">{{feature.displayString + ':'}}</p>
                    <label class="license-value" *ngIf="!feature.booleanFeature">{{feature.value | number}}</label>
                    <label class="license-value license-feature-availability"
                           *ngIf="feature.booleanFeature"
                           [ngClass]="feature.value == 1 ? 'featureEnabled' : 'featureDisabled'">
                        {{feature.value == 1 ? 'enabled' : 'disabled'}}
                    </label>
                </div>
            </div>
        </div>
    </arm-form>
</div>
